import { Box, Stack } from '@mui/material'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogTitle from '@mui/material/DialogTitle'
import Slide from '@mui/material/Slide'
import { TransitionProps } from '@mui/material/transitions'
import QRCode from 'qrcode'
import React, { ReactElement, useEffect, useRef, useState } from 'react'
import ReactToPrint from 'react-to-print'

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="down" ref={ref} {...props} />
})
interface Props {
  open: boolean
  url: string
  header?: ReactElement
  footer?: ReactElement
  handleClose: () => void
}
export default function DialogQR({
  open,
  url,
  header,
  footer,
  handleClose,
}: Props) {
  const componentRef = useRef(null)
  const [qrImg, setQrImg] = useState('')
  useEffect(() => {
    QRCode.toDataURL(url, {
      errorCorrectionLevel: 'H',
      color: {
        dark: '#000',
        light: '#ffffff',
      },
      margin: 2,
      scale: 20,
      type: 'image/png',
    }).then((str) => setQrImg(str))
  }, [url])

  return (
    <>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        fullWidth
        maxWidth={'xs'}
        onClose={(_e, reason) => {
          if (reason !== 'backdropClick') {
            handleClose()
          }
        }}
      >
        <DialogTitle
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          印刷用二次元コードの表示
        </DialogTitle>
        <Box ref={componentRef} className="print-area">
          <Box><h3 className="print-title">{header}</h3></Box>
          <Box className="system-name"><span>{footer}</span></Box>
          <img src={qrImg} width="100%" alt="qr-code" />
          <Box className="text-center system-name"><span>なぞしゅう</span></Box>
        </Box>
        <DialogActions>
          <Stack
            width="100%"
            direction="row"
            justifyContent="space-around"
            className="mb-4"
          >
            <Button
              // className='w-9/12'
              variant="outlined"
              color="info"
              onClick={() => handleClose()}
            >
              閉じる
            </Button>
            <ReactToPrint
              bodyClass="flex justify-center items-center h-screen w-9/12 m-auto"
              trigger={() => (
                <Button variant="outlined" color="info">
                  印刷
                </Button>
              )}
              content={() => componentRef.current}
            />
          </Stack>
        </DialogActions>
      </Dialog>
    </>
  )
}
